// HelpPill.jsx -- floating help button + CS agent slide-over (PD47d CS-S4)
// ASCII only. var declarations. ESM only. Inline styles.
import { useContext, useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeContext } from '../lib/theme.js';
import SmartInputBar from './SmartInputBar.jsx';

var FONT = "'IBM Plex Sans', -apple-system, sans-serif";

// Hide on surfaces that have their own CS chat
var HIDDEN_PATHS = ['/platform', '/admin', '/voice'];

export default function HelpPill() {
  var theme = useContext(ThemeContext);
  var location = useLocation();
  var _open = useState(false); var open = _open[0]; var setOpen = _open[1];
  var _val = useState(''); var val = _val[0]; var setVal = _val[1];
  var inputRef = useRef(null);

  // Hide on excluded paths
  var hidden = HIDDEN_PATHS.some(function(p) { return location.pathname.startsWith(p); });
  // Hide in popout mode
  try { if (new URLSearchParams(window.location.search).get('popout') === 'true') hidden = true; } catch(e) {}

  useEffect(function() {
    if (open && inputRef.current) inputRef.current.focus();
  }, [open]);

  if (hidden) return null;

  return (
    <>
      {/* Floating pill button */}
      {!open && (
        <button
          data-testid="help-pill"
          onClick={function() { setOpen(true); }}
          style={{
            position: 'fixed', bottom: 20, right: 20, zIndex: 900,
            width: 48, height: 48, borderRadius: '50%',
            background: theme.accent, color: '#fff', border: 'none',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(79, 110, 247, 0.3)',
            transition: 'transform 0.15s'
          }}
          onMouseEnter={function(e) { e.target.style.transform = 'scale(1.08)'; }}
          onMouseLeave={function(e) { e.target.style.transform = 'scale(1)'; }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </button>
      )}

      {/* Slide-over panel */}
      {open && (
        <div style={{
          position: 'fixed', top: 0, right: 0, bottom: 0, width: 380, zIndex: 950,
          background: theme.surface, borderLeft: '1px solid ' + theme.border,
          boxShadow: '-8px 0 24px rgba(0,0,0,0.08)',
          display: 'flex', flexDirection: 'column', fontFamily: FONT
        }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '1px solid ' + theme.border, flexShrink: 0 }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600 }}>Help</div>
              <div style={{ fontSize: 10, color: theme.textMuted }}>Customer Success</div>
            </div>
            <button onClick={function() { setOpen(false); }} style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: 'transparent', cursor: 'pointer', color: theme.textSecondary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          {/* Context hint */}
          <div style={{ padding: '8px 16px', fontSize: 10, color: theme.textMuted, background: theme.surfaceInset, borderBottom: '1px solid ' + theme.border }}>
            Viewing: {location.pathname}
          </div>

          {/* Thread area */}
          <div style={{ flex: 1, overflow: 'auto', padding: '16px' }}>
            <div style={{ textAlign: 'center', color: theme.textMuted, fontSize: 12, padding: '32px 0' }}>
              Ask anything about Hub -- configuration, agents, connectors, billing.
            </div>
          </div>

          {/* Input */}
          <div style={{ padding: '8px 12px 12px', borderTop: '1px solid ' + theme.border, flexShrink: 0 }}>
            <SmartInputBar
              agent="agent_customer_success"
              value={val}
              onChange={function(e) { setVal(e.target.value); }}
              inputRef={inputRef}
            />
          </div>
        </div>
      )}

      {/* Backdrop when open */}
      {open && (
        <div onClick={function() { setOpen(false); }} style={{
          position: 'fixed', inset: 0, zIndex: 940, background: 'rgba(0,0,0,0.15)'
        }} />
      )}
    </>
  );
}
